import { make } from 'vuex-pathify';
import { DelinquencyCommentsService } from '@/modules/delinquency/services/delinquency-comments.service';

import Logger from '@/lib/logger.js';

const service = new DelinquencyCommentsService();

export const state = {
  delinquencyComments: []
};

export const mutations = {
  ...make.mutations(state)
};

export const getters = {
  ...make.getters(state)
};

export const actions = {
  async createDelinquencyComment(_, data) {
    try {
      const { data: res } = await service.createDelinquencyComment(data);
      return res;
    } catch (error) {
      Logger.error('Creating Delinquency Comment', error);
      throw error;
    }
  },
  async updateDelinquencyComment(_, data) {
    try {
      const { data: res } = await service.updateDelinquencyComment(data);
      return res;
    } catch (error) {
      Logger.error('Updating Delinquency Comment', error);
      throw error;
    }
  },
  async deleteDelinquencyComment(_, data) {
    try {
      const { data: res } = await service.deleteDelinquencyComment(data);
      return res;
    } catch (error) {
      Logger.error('Deleting Delinquency Comment', error);
      throw error;
    }
  },
  async findDelinquencyCommentByFilter({ commit }, data) {
    try {
      const { data: res } = await service.findDelinquencyCommentByFilter(data);
      commit('SET_DELINQUENCY_COMMENTS', res);
      return res;
    } catch (error) {
      Logger.error('Finding Delinquency Comment By Filter', error);
      throw error;
    }
  }
};
